<template>
    <div>
        <div class="halloween__footer" v-if="isHalloween">
            <img src="/public/halloween/footer.png" alt="Halloween">
        </div>
        <div class="easter__footer" v-if="isEaster">
            <img :src="easterFooter()" alt="Easter">
        </div>
        <v-footer>
            <div class="container">
                <div class="footer">
                    <language-switcher/>

                    <div class="footer__bigMenu" v-if="bigMenuPart">
                        <single-page-part :pagePart="bigMenuPart"/>
                    </div>
                    <div class="footer__bigMenu" v-else-if="contactUsEnabled">
                        <a @click="supportDialog = true">
                            {{ $t('front.help.button.contact_us') }}
                        </a>
                        <v-dialog content-class="dialog-support" v-model="supportDialog" max-width="900px"
                                  :persistent="isDialogPersistent">
                            <support-popup @close="supportDialog = false" v-if="supportDialog"/>
                        </v-dialog>
                    </div>
                    <div class="footer__smallMenu" v-if="smallMenuPart">
                        <single-page-part :pagePart="smallMenuPart"/>
                    </div>
                    <div class="footer__help" v-if="helpPart">
                        <single-page-part :pagePart="helpPart"/>
                    </div>
                    <div class="footer__listPartners" v-if="partnersPart">
                        <single-page-part :pagePart="partnersPart"/>
                    </div>
                    <div class="footer__listProvider" v-if="providersPart">
                        <single-page-part :pagePart="providersPart"/>
                    </div>
                    <div class="footer__copyright" v-if="copyrightPart">
                        <single-page-part :pagePart="copyrightPart"/>
                    </div>
                </div>
            </div>
        </v-footer>
    </div>
</template>

<script>
import appConfig, {events} from "../../../config/app";
import {brandName, features} from "../../../config/app";
import DialogSettings from "../../mixins/dialogSettings";

export default {
    name: "TheFooter",

    mixins: [DialogSettings],

    data: function () {
        return {
            supportDialog: false,
        };
    },

    computed: {
        bigMenuPart() {
            return features.footer.bigMenu && this.$store.getters.getLayoutPagePart('footerBigMenu');
        },

        smallMenuPart() {
            return features.footer.smallMenu && this.$store.getters.getLayoutPagePart('footerSmallMenu');
        },

        partnersPart() {
            return features.footer.partners && this.$store.getters.getLayoutPagePart('footerPartners');
        },

        helpPart() {
            return features.footer.help && this.$store.getters.getLayoutPagePart('footerHelp');
        },

        providersPart() {
            return features.footer.providers && this.$store.getters.getLayoutPagePart('footerProviders');
        },

        copyrightPart() {
            return features.footer.copyright && this.$store.getters.getLayoutPagePart('footerCopyright');
        },

        contactUsEnabled() {
            return appConfig.features.footer.contactUs;
        },

        isHalloween() {
            return events.halloween;
        },

        isEaster() {
            return events.easter;
        },
    },

    methods: {
        easterFooter() {
            return `/public/${brandName}/easter/footer.png`;
        },
    },
}
</script>

<style lang="sass">
@import "sass/components/layout/TheFooter"
</style>